import { render, staticRenderFns } from "./DocumentosCompraDiretaCabecalho.vue?vue&type=template&id=fa1d1fca&scoped=true"
import script from "./DocumentosCompraDiretaCabecalho.vue?vue&type=script&lang=js"
export * from "./DocumentosCompraDiretaCabecalho.vue?vue&type=script&lang=js"
import style0 from "./DocumentosCompraDiretaCabecalho.vue?vue&type=style&index=0&id=fa1d1fca&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1d1fca",
  null
  
)

export default component.exports